<template>
  <div>
    <v-card>
      <h2>{{ $t("app_partner") }}</h2>
      <v-carousel
        cycle
        height="200"
        interval="13500"
        hide-delimiter-background
        :show-arrows="items.length > 1"
        show-arrows-on-hover
      >
        <v-carousel-item v-for="(item, i) in items" :key="i">
          <div class="advertise-img-wrapper">
            <a :href="item.url" target="_blank">
              <img :src="item.src" class="advertiseImg" />
            </a>
          </div>
        </v-carousel-item>
      </v-carousel>
    </v-card>
  </div>
</template>

<script>
import { getUserLocale } from "@/utils/localStorageUtils";

export default {
  computed: {
    items() {
      const userLocale = getUserLocale();
      if (userLocale === "sk") {
        return [];
      } else {
        return [
          {
            src: "https://easi-score.b-cdn.net/dermweb-logo.png",
            url: "https://www.dermweb.cz/",
          },
        ];
      }
    },
  },
};
</script>

<style scoped lang="scss">
.v-card {
  padding: 2em;
  min-height: 100%;
  box-shadow: 0px 0px 18px 0px rgba(209, 209, 209, 1);
}
h2 {
  color: gainsboro;
}

.advertise-img-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  a {
    width: 75%;
  }
}

.advertiseImg {
  width: 100%;
}
</style>
